import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UserGroup } from 'src/app/model';
import { IonicSelectableComponent, IonicSelectableFooterTemplateDirective, IonicSelectablePlaceholderTemplateDirective } from 'ionic-selectable';
import { getListAsync, innerScrollEl, ITEMS_LIMIT, returnScrollPosition, scrollToSelected } from 'src/app/app.utils';
import { Subscription } from 'rxjs';
import { HelperProvider } from 'src/app/providers';
import { IonicModule } from '@ionic/angular';
import { UmStoreService } from 'src/app/store/um-store.service';
import { DmStoreService } from 'src/app/store/dm-store.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LocaLstorageService } from 'src/app/store/localstorage.service';

@Component({
  selector: 'app-owner-select',
  templateUrl: './owner-select.component.html',
  styleUrls: ['./owner-select.component.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, CommonModule, IonicSelectableComponent, IonicSelectableFooterTemplateDirective, IonicSelectablePlaceholderTemplateDirective],
})
export class OwnerSelectComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private OwnerId?: number;
  private page = 1;

  public owners$ = this.umStore.owners$;

  @ViewChild('ownerSelectComponent') ownerSelectComponent: IonicSelectableComponent;

  @Input()
  set ownerId(val) {
    this.OwnerId = val;
  }
  get ownerId() {
    return this.OwnerId;
  }

  @Input() disabled: boolean;

  constructor(
    private umStore: UmStoreService,
    private helper: HelperProvider,
    private dmStore: DmStoreService,
    private localStorageService: LocaLstorageService,
  ) { }

  ngOnInit() {
    this.subscription = this.umStore.selectedOwner$.subscribe(owner => {
      this.ownerId = owner?.id;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public selectOwner() {
    this.ownerSelectComponent.confirm();
    this.ownerSelectComponent.close();

    this.umStore.selectOwner(this.ownerId);
    this.dmStore.selectZone();
    this.localStorageService.selectedProject = undefined;
  }

  public onOpen(event: { component: IonicSelectableComponent }, isFirstEntry: boolean) {
    if (!this.ownerId) {
      return;
    }
    const { items } = event.component;
    const isOwnerInItems = items.find(item => item.id === this.ownerId);
    const scrollEl = innerScrollEl();

    if (!scrollEl) {
      return;
    }

    if (!isOwnerInItems) {
      this.helper.showLoading();
      getListAsync<UserGroup>(this.umStore.owners, this.page, ITEMS_LIMIT, 10).subscribe(owners => {
        owners = event.component.items.concat(owners);

        event.component.items = owners;
        this.page++;

        this.onOpen(event, false);
      });

      return;
    }

    if (!isFirstEntry) {
      setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const scrollVal = (document.querySelector('ion-item.ionic-selectable-item-is-selected') as any)?.offsetTop || 0;
        returnScrollPosition(scrollEl, scrollVal - scrollEl.clientHeight);
        this.helper.hideLoading();
      }, 300);
    }
  }

  public filterOwners(owners: UserGroup[], text: string) {
    return owners.filter(owner => {
      return owner.name.toLowerCase().includes(text);
    });
  }

  public getMoreOwners(event: {
    component: IonicSelectableComponent,
    text: string
  }) {
    const scrollEl = innerScrollEl();

    if (!scrollEl) {
      return;
    }

    const scrollVal = scrollEl.scrollTop;

    const text = (event.text || '').trim().toLowerCase();

    if (this.page >= Math.ceil(this.umStore.owners.length / ITEMS_LIMIT)) {
      event.component.disableInfiniteScroll();
      return;
    }

    getListAsync<UserGroup>(this.umStore.owners, this.page, ITEMS_LIMIT).subscribe(owners => {
      owners = event.component.items.concat(owners);

      if (text) {
        owners = this.filterOwners(owners, text);
      }

      event.component.items = owners;
      event.component.endInfiniteScroll();
      this.page++;

      if (!text) {
        returnScrollPosition(scrollEl, scrollVal);
      }
    });
  }

  public searchOwners(event: {
    component: IonicSelectableComponent,
    text: string
  }) {
    const text = event.text.trim().toLowerCase();
    event.component.startSearch();

    if (!text) {
      event.component.items = this.umStore.owners.slice(0, this.page * ITEMS_LIMIT);
      event.component.endSearch();
      scrollToSelected();
      return;
    }

    event.component.items = this.filterOwners(this.umStore.owners, text);
    event.component.enableInfiniteScroll();
    event.component.endSearch();
  }

}
